module.exports = __webpack_public_path__ + "static/media/maaa.2397afea.ogg";